import { render, staticRenderFns } from "./X-modale-contact-reno.vue?vue&type=template&id=54091879&scoped=true"
import script from "./X-modale-contact-reno.vue?vue&type=script&lang=js"
export * from "./X-modale-contact-reno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54091879",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitnami/deploy/oscar_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54091879')) {
      api.createRecord('54091879', component.options)
    } else {
      api.reload('54091879', component.options)
    }
    module.hot.accept("./X-modale-contact-reno.vue?vue&type=template&id=54091879&scoped=true", function () {
      api.rerender('54091879', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/intervention/X-modale-contact-reno.vue"
export default component.exports